// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"787":"29093faf","845":"fa3fece4"}[chunkId] + ".chunk.js";
};